import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  ViewContainerRef,
  ViewChildren
} from '@angular/core';
import { isBs3 } from '../utilities/ng2-bootstrap-config';
import { DatePickerInnerComponent } from './datepicker-inner.component';
import * as moment_ from '../utilities/lib-moment/moment-with-locales.custom.min';
import { DatepickerService } from './datepicker.shared.service';
import {
  getBrowserLocale,
  trasformToDate
} from './datepicker-utility';
const moment = moment_;
@Component({
  selector: 'axis-monthpicker',
  template: `
<table *ngIf="datePicker.datepickerMode==='month'" role="grid">
  <thead>
    <tr>
      <th>
        <button *ngIf="!japanLocale" type="button" axis-button data-kind="icon" 
                (click)="datePicker.move(-1)" tabindex="-1">
          <span class="material-icons">keyboard_arrow_left</span>
        </button></th>
      <th [attr.colspan]="(((datePicker.monthColLimit - 2) <= 0) ? 1 : (datePicker.monthColLimit - 2))">
      <button *ngIf="!japanLocale" [id]="datePicker.uniqueId + '-title'"
            type="button" axis-button class="datepicker-btn"
            (click)="datePicker.toggleMode(1)"
            [disabled]="datePicker.datepickerMode === maxMode"
            [ngClass]="{'date-disabled': datePicker.datepickerMode === maxMode}" tabindex="-1">{{title}}
      </button>
      <button *ngIf="japanLocale" [id]="datePicker.uniqueId + '-title1'"
            type="button" axis-button class="datepicker-btn"
            (click)="datePicker.toggleMode(1)"
            [disabled]="datePicker.datepickerMode === maxMode"
            [ngClass]="{'date-disabled': datePicker.datepickerMode === maxMode}" tabindex="-1">
          {{title1}}
      </button>
      <button *ngIf="japanLocale" [id]="datePicker.uniqueId + '-title'"
              type="button" axis-button class="datepicker-btn"
              (click)="datePicker.toggleMode(0)"
              [disabled]="datePicker.datepickerMode === maxMode"
              [ngClass]="{'date-disabled': datePicker.datepickerMode === maxMode}" tabindex="-1">{{title}}
      </button>
      </th>
      <th>
        <button *ngIf="!japanLocale" type="button" axis-button data-kind="icon" 
                (click)="datePicker.move(1)" tabindex="-1">
          <span class="material-icons">keyboard_arrow_right</span>
        </button>
      </th>
    </tr>
  </thead>
  <tbody class="tbody-month">
    <tr *ngFor="let rowz of rows">
      <td *ngFor="let dtz of rowz" role="gridcell" id="{{dtz.uid}}" [ngClass]="dtz.customClass">
        <button #monthRef type="button" class="axis-btn"
                [ngClass]="{
                  'btn-link': isBs4 && !dtz.selected && !datePicker.isActive(dtz),
                  'date-today': dtz.selected || (isBs4 && !dtz.selected && datePicker.isActive(dtz)),
                  'date-disabled': dtz.disabled,
                  'date-selected': !isBs4 && datePicker.isActive(dtz)
                }"
                [disabled]="dtz.disabled"
                (click)="datePicker.select(dtz.date)" tabindex="-1">
          <span [ngClass]="{'text-success': isBs4 && dtz.current, 'date-today': !isBs4 && dtz.current}">{{dtz.label}}</span>
        </button>
      </td>
    </tr>
  </tbody>
</table>
<div *ngIf="this.datePicker.datepickerMode === 'month' && this.datePicker.selectOnMonth" class="axis-datepicker-footer">
    <button type="button" axis-button data-kind="link" (click)="clear()" data-size="small">Clear</button>
    <!-- <button type="button" axis-button data-kind="primary" class="axis-btn" data-size="small"
      (click)="closeDatePicker($event)">Done</button> -->
</div>
  `
})
export class MonthPickerComponent implements OnInit {
  public title: string;
  public title1: any;
  public rows: any[] = [];
  public datePicker: DatePickerInnerComponent;
  public maxMode: string;
  public selectedMonth: any;
  private localeLanguage: string;
  public japanLocale = false;
  public validKeyPressed = false;
  public selectedYearNumber: any;
  @ViewChildren('monthRef') monthRef: QueryList<ViewContainerRef>;

  public constructor(datePicker: DatePickerInnerComponent, private el: ElementRef, private datepickerService: DatepickerService) {
    this.datePicker = datePicker;

  }

  public get isBs4(): boolean {
    return !isBs3();
  }

  clear() {
    this.datepickerService.inputElement.subscribe(result => {
      result['nativeElement'].firstChild.children[0].focus();
    });
    this.datePicker.activeDate = void 0;
    this.datePicker.dateDisabled = undefined;
    this.datePicker.closeEvent.emit(this.datePicker.activeDate);
  }

  closeDatePicker(event: any) {
    this.datePicker.closeEvent.emit(this.datePicker.activeDate);
  }

  public ngOnInit(): void {
    let self: any = '';
    self = this;
    this.datePicker.stepMonth = { years: 1 };
    this.datePicker.setRefreshViewHandler(function (): void {
      const useLocale  = self.datepickerService.useLocale;
      this.localeLanguage = (useLocale) ? useLocale : getBrowserLocale();
      moment.locale(this.localeLanguage);
      const months: any[] = new Array(12);
      const year: number = this.activeDate.getFullYear();
      let date: Date;

      for (let i = 0; i < 12; i++) {
        date = new Date(year, i, 1);
        date = this.fixTimeZone(date);
        months[i] = this.createDateObject(date, this.formatMonth);
        months[i].uid = this.uniqueId + '-' + i;
      }
      self.title = this.dateFilter(this.activeDate, this.formatMonthTitle);
      self.rows = this.split(months, self.datePicker.monthColLimit);
      if (this.localeLanguage === 'ja') {
        self.japanLocale = true;
        const monthLocale = moment.monthsShort();
        let k = 0;
        for (let i = 0; i < 4; i++) {
          for (let j = 0; j < 3; j++) {
            self.rows[i][j].label = monthLocale[k];
            k = k + 1;
          }
        }
        self.title1 = new Date(this.activeDate).getFullYear().toString().concat('年');
        self.title = monthLocale[new Date(this.activeDate).getMonth()];
      }
    }, 'month');

    this.datePicker.setCompareHandler(function (
      date1: Date,
      date2: Date
    ): number {
      if (date1 !== null && date2 !== null) {
        const d1 = new Date(date1.getFullYear(), date1.getMonth());
        const d2 = new Date(date2.getFullYear(), date2.getMonth());
        return d1.getTime() - d2.getTime();
      }
    }, 'month');
    this.datePicker.refreshView();
  }

  @HostListener('keyup', ['$event', 'this.monthRef'])
  onKeyup(e: any, monthRef: any) {
    e.preventDefault();
    this.validKeyPressed = true;
    if ((e.code !== 'Tab' || e.keyCode !== 9) && this.datePicker.datepickerMode === 'month') {
      this.monthUpdateOnKeyPress(monthRef, e);
    }
  }

  monthUpdateOnKeyPress(monthRef: any, e: any) {
    monthRef.forEach(element => {
      const tempElement = element.nativeElement;
      if (
        tempElement.classList.contains('date-selected') ||
        tempElement.classList.contains('date-today')
      ) {
        const selectedMonthName = element.nativeElement.textContent;
        const intialselectedMonth = moment().month(selectedMonthName).format('M');
        const selectedMonthNumber = parseInt(intialselectedMonth, 10);
        if (this.japanLocale) {
          // japan
          this.selectedYearNumber = parseInt(this.title1, 10);
        } else {
          // english
          this.selectedYearNumber = parseInt(this.title, 10);
        }
        this.selectedMonth = new Date(this.selectedYearNumber, (selectedMonthNumber - 1), 1);
        if (e.code === 'ArrowRight' || e.keyCode === 39) {
          this.selectedMonth.setMonth(selectedMonthNumber);
        } else if (e.code === 'ArrowLeft' || e.keyCode === 37) {
          this.selectedMonth.setMonth(selectedMonthNumber - 2);
        } else if (e.code === 'ArrowDown' || e.keyCode === 40) {
          this.selectedMonth.setMonth(selectedMonthNumber + 2);
        } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
          this.selectedMonth.setMonth(selectedMonthNumber - 4);
        } else if (e.code === 'Home' || e.keyCode === 36) {
          this.selectedMonth = new Date(this.selectedYearNumber, 0, 1);
        } else if (e.code === 'End' || e.keyCode === 35) {
          this.selectedMonth = new Date(this.selectedYearNumber, 11, 1);
        } else if (e.code === 'Escape' || e.keyCode === 27) {
          this.datepickerService.inputElement.subscribe(result => {
            const inputValue = result['nativeElement'].children[0].firstChild.value;
            if (inputValue === '') {
              this.clear();
              result['nativeElement'].firstChild.children[0].focus();
            } else {
              this.datePicker.closeEvent.emit(new Date(inputValue));
              result['nativeElement'].firstChild.children[0].focus();
            }
          });
        } else if ((e.code === 'PageUp' || e.keyCode === 33) && e.altKey === false) {
          this.selectedMonth = new Date(this.selectedYearNumber - 1, (selectedMonthNumber - 1), 1);
        } else if ((e.code === 'PageDown' || e.keyCode === 34) && e.altKey === false) {
          this.selectedMonth = new Date(this.selectedYearNumber + 1, (selectedMonthNumber - 1), 1);
        } else if (e.altKey === true && (e.code === 'PageDown' || e.keyCode === 34)) {
          this.selectedMonth = new Date(this.selectedYearNumber + 10, (selectedMonthNumber - 1), 1);
        } else if (e.altKey === true && (e.code === 'PageUp' || e.keyCode === 33)) {
          this.selectedMonth = new Date(this.selectedYearNumber - 10, (selectedMonthNumber - 1), 1);
        } else if ((e.altKey === true && e.ctrlKey === true) && (e.code === 'KeyC' || e.keyCode === 67)) {
          this.clear();
        } else {
          this.validKeyPressed = false;
        }

        if (this.validKeyPressed) {
          this.datePicker.select(this.selectedMonth, false);
        }


        if (e.code === 'Enter' || e.keyCode === 13) {
          this.datePicker.select(this.selectedMonth, true);
          this.datepickerService.inputElement.subscribe(result => {
            result['nativeElement'].firstChild.children[0].focus();
          });
        }
      }
    });
  }
}
